import { useMutation } from '@tanstack/react-query';

import { useDeps } from '@Contexts/DI';
import { useRequest } from '@Contexts/Request';
import useUpdateProfileData from '@Hooks/useUpdateProfileData';
import useNavigation from '@Navigation/useNavigation';
import isPrivatePage from '@Navigation/isPrivatePage';

import type { UseMutateFunction } from '@tanstack/react-query';

export function useLogout(): [UseMutateFunction] {
  const { region } = useRequest();
  const { cabinetApi } = useDeps();
  const updateProfileData = useUpdateProfileData();
  const navigation = useNavigation();

  const { mutate } = useMutation({
    mutationFn: () => {
      return cabinetApi.logout();
    },
    onSuccess: async () => {
      // Если в момент выхода пользователь находится на странице личного кабинета, то его нужно отправить на главную
      // В других случаях пользователь остаётся на текущей странице
      if (isPrivatePage(navigation.pathname)) {
        await navigation.openPage({ url: `/${region}` });
      }

      setTimeout(() => {
        updateProfileData();
      }, 300);
    },
  });

  return [mutate];
}
